import React from 'react';
import './test-completed.css'
import { Link } from "react-router-dom";
import { useAuthState } from '../../../Context';
import ProgressBar from '../../ProgressBar/ProgressBar';
import Otsukare from "../../../Images/otsukare@2x.png";
import HeaderLogo from '../../HeaderLogo/HeaderLogo'

let testProgressBar = 3

export default function TestCompleted({score}) {
  const userDetails = useAuthState();
  const user = userDetails.user;
  return (
    <>
      <HeaderLogo />
      <ProgressBar testProgressBar={testProgressBar}/>
      <div className="color-test-completed">
      <div className="head welcome-text-button-results-container">
          <div className="welcome-text-container">
            <h1>処理機能テスト</h1>
          </div>
        </div>

        <div className="text-box">
        <div className="flex">
            <div className="exam-icon">
              <img src={Otsukare} alt="おつかれさまでした" />
            </div>
            <div className='instructions-text'>
          <h2 className="instructions-text-center">おつかれさまでした。</h2>
          {user.is_admin && (
            <p className="instructions-text-center">
              Your Total Score is: {score}
            </p>
          )}
          <p className="instructions-text-center">
            <b>これでテスト終了です。</b>
          </p>
        </div>
</div>
</div>

        {/* <div className="startText">次のテストに進みます。</div> */}
        <Link to="/results" className="continue-button"><h2>結果を表示する</h2></Link>
        {/* <button className="continue-button" >Continue</button> */}
      </div>
    </>
  )
}
